export const MAX_FIELDSET_CHILDREN = 100;

export const MAX_FIELDSET_DEPTH = 2;

export const MAX_UPLOAD_LIMIT = 20;

// Maximum number of options a `select` custom field can have. Dropdown display
// mode handles long lists fine; radio mode is the only one that suffers, but we
// keep a single cap for simplicity. Real-world equipment pick-lists (e.g. solar
// panel / inverter models) exceed the old limit of 20, so this is set higher.
export const MAX_SELECT_OPTIONS = 100;

// This is too long UX wise, but there's already data this big and users can't
// rename identifiers, so we need to allow it. In the future we should consider
// migrating data to a smaller length and enforcing it.
export const MAX_IDENTIFIER_LENGTH = 250;

export const MAX_LABEL_LENGTH = 100;

export const MAX_DESCRIPTION_LENGTH = 1023;

/**
 * Identifiers that collide with JavaScript's prototype chain. react-hook-form's
 * internal `set` helper silently refuses to write keys `__proto__`,
 * `constructor`, and `prototype` as a prototype-pollution guard, which then
 * makes the corresponding form field unregisterable and crashes on edit.
 */
export const RESERVED_CUSTOM_FIELD_IDENTIFIERS = [
  '__proto__',
  'constructor',
  'prototype',
] as const;
